export default "<h3>September 30, 2018</h3>\r\n<p>Update 0.33 fixes bugs.</p>";